import Repository from "../../repository";

export default {
    GetRecently: (payload) => Repository.post(`/api/Guests/PostPublish/GetRecently`, payload),
    GetDetail: (payload) => Repository.post(`/api/Guests/PostPublish/GetDetail`, payload),
    GetRandom: (payload) => Repository.post(`/api/Guests/PostPublish/GetRandom`, payload),
    GetTop: (payload) => Repository.post(`/api/Guests/PostPublish/GetTop`, payload),
    Get: (payload) => Repository.post(`/api/Guests/PostPublish/Get`, payload),

}
